import { Button } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { getBorder } from "utils/Styles";
import AddIcon from "@mui/icons-material/Add";

const Toolbar = (props) => {
	const { t } = useTranslation();
	const { rows, setRows, selectedDay } = props;

	return (
		<GridToolbarContainer
			sx={{ borderBottom: (theme) => getBorder(theme.palette.mode) }}
		>
			<Button
				color="primary"
				startIcon={<AddIcon />}
				variant="contained"
				disableElevation
				sx={{ m: 1 }}
				onClick={() => {
					if (rows.length !== 0) {
						const lastRow = rows[rows.length - 1];

						console.log("lastRow", lastRow);

						let newRow = {
							type: "REGULAR",
							start_ts: lastRow.end_ts.clone(),
							end_ts: lastRow.end_ts.clone().set({
								hour: 0,
								minute: 0,
								second: 0,
							}),
						};

						setRows((prev) =>
							[...prev, newRow].map((row, index) => ({
								id: index,
								type: row.type,
								start_ts: row.start_ts,
								end_ts: row.end_ts,
							}))
						);
					} else {
						setRows([
							{
								id: 0,
								type: "REGULAR",
								start_ts: selectedDay.clone().set({
									hour: 0,
									minute: 0,
									second: 0,
								}),
								end_ts: selectedDay.clone().set({
									hour: 0,
									minute: 0,
									second: 0,
								}),
							},
						]);
					}

					/* let new_row = {
						type: "REGULAR",
						start_ts:
							rows.length === 0
								? selectedDay?.clone().set({
										hour: 0,
										minute: 0,
										second: 0,
								  })
								: selectedDay?.clone().set({
										hour: rows[
											rows.length - 1
										]?.end_ts?.hour(),
										minute: rows[
											rows.length - 1
										]?.end_ts?.minute(),
										second: rows[
											rows.length - 1
										]?.end_ts?.second(),
								  }),
						end_ts: null,
					};

					setRows(
						[...rows, new_row].map((row, index) => ({
							id: index,
							type: row.type,
							start_ts: selectedDay.clone().set({
								hour: row.start_ts.hour(),
								minute: row.start_ts.minute(),
								second: row.start_ts.second(),
							}),
							end_ts: selectedDay.clone().set({
								hour: row.end_ts?.hour(),
								minute: row.end_ts?.minute(),
								second: row.end_ts?.second(),
							}),
						}))
					); */
				}}
				disabled={
					rows[rows.length - 1]?.start_ts === null ||
					rows[rows.length - 1]?.end_ts === null
				}
			>
				{t(
					"timekeeper.schedule.table.modals.add.table.buttons.new_row"
				)}
			</Button>
		</GridToolbarContainer>
	);
};

export { Toolbar };
